@if (errorTitle) {
  <h1 class="mb-0 font-light">
    {{ errorTitle }}
  </h1>
}
@if (perex) {
  <h4 class="mt-10 mb-0">
    {{ perex }}
  </h4>
}
@if (text) {
  <p class="mt-2 mb-0">
    {{ text }}
  </p>
}
@if (image && errorTitle) {
  <div>
    <img [src]="image" [alt]="errorTitle" class="mt-12.5 mb-8" />
  </div>
}
<ng-content></ng-content>
